export default __webpack_public_path__ + "static/media/Highlord's Crossbow.32ec6a17.jpg";